import illustration from '@svg/illustrations/404.svg';
import Typography from '@components/common/typography';
import Button from '@components/common/button';
import { useNavigate } from 'react-router-dom';
import { routes } from '@const/routes';
import styles from './styles.module.scss';
import { useHelpCenterModals } from '@hooks/modals/useHelpCenterModals';
import { useLocales } from '@hooks/helpers/useLocales';

const NotFoundPage = () => {
    const navigate = useNavigate();
    const { handleOpenSubmitRequestModal } = useHelpCenterModals();
    const { submitLocale } = useLocales();
    return (
        <div className={styles.wrapper}>
            <img src={illustration} alt="page not found" />
            <Typography className={styles.big_text} variant="h4">
                Ooops! Page not found
            </Typography>
            <Typography variant="body3" className={styles.description}>
                Sorry, the page you are looking for doesn't exist. If you think something is broken,
                please report an issue
            </Typography>
            <div className={styles.actions}>
                <Button
                    className={styles.button}
                    variant="outlined-primary"
                    onClick={handleOpenSubmitRequestModal}>
                    {submitLocale('report_issue')}
                </Button>
                <Button
                    className={styles.button}
                    variant="primary"
                    onClick={() => navigate(routes.dashboard)}>
                    {submitLocale('go_to_home')}
                </Button>
            </div>
        </div>
    );
};

export default NotFoundPage;
